export const CLOUD_NAME = 'ampedup';
